import { getUnleashAdminRouter } from '@inkitt/contracts-common';
import { c } from '../../contract';
import { UnleashContext } from '../../types';

export const unleashRouter = c.router(
  {
    getContext: {
      summary: 'Gets unleash context',
      method: 'GET',
      path: '/context',
      responses: {
        200: c.type<UnleashContext>(),
      },
    },
    admin: getUnleashAdminRouter(c),
  },
  { pathPrefix: '/unleash' },
);
